import { get_axios_instance, api_variables } from "@/apis/variables.js";

var axios_instance = get_axios_instance(api_variables.SERVICE_LEAVES_SALARY);

//const _pk_name = "id";

const state = {
    data: [],
    statutoryBonusData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
        //console.log("fetched data", state.data);
    },

    statutoryBonus: (state, payload) => {
        state.statutoryBonusData = payload;
    },
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    }
};

const actions = {
    async fetch({ commit }, payload) {
        // //console.log(
        //     "[state/dashboard/statutory_bonus/fetchAll] Calling API..."
        // );
        //console.log("payload paygroup id", payload);
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`);
            commit("setFetching", false);
            // //console.log(
            //     "[state/payroll/statutory_bonus/fetchAll] res: ",
            //     res
            // );
            if (res.status == 200) {
                commit("set", res);
            }
            return res;
        } catch (err) {
            //console.log(err);
        }
    },

    async create({ commit }, payload) {
        //console.log("[state/statutory_bonus/create] Adding...", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance.post("/", payload);
            commit("setSaving", false);
            //console.log("[state/statutory_bonus/create] res: ", res);
            if (res.status == 200) {
                commit("statutoryBonus", payload);
            }
            return res;
        } catch (err) {
            //console.log(err);
        }
    },

    async update({ commit }, payload) {
        // //console.log(
        //     "[state/payroll/lopsandrlops/update] Updating... Display payload",
        //     payload
        // );
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/${payload.id}`, payload);
            commit("setSaving", false);
            //console.log("[state/payroll/lopsandrlops/update] res: ", res);
            if (res.status == 200) {
                commit("updateStatutoryBonus", res.data);
            }
            return res;
        } catch (err) {
            //console.log(err);
        }
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};